import * as React from "react";
const SvgFiRrHatChef = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-hat-chef_svg__a)">
      <path
        fill="#062147"
        d="M23.836 4.705c-.763-3.113-5.05-4.759-7.676-3.084a6.16 6.16 0 0 0-8.32 0C1.41-1.658-3.587 7.73 3.326 10.713a.935.935 0 0 1 .674.851V19.5A4.5 4.5 0 0 0 8.5 24h7a4.5 4.5 0 0 0 4.5-4.5v-7.936a.93.93 0 0 1 .674-.851 5.017 5.017 0 0 0 3.162-6.008M18 19.5a2.5 2.5 0 0 1-2.5 2.5h-7A2.588 2.588 0 0 1 6 19h12zm2-10.672a2.91 2.91 0 0 0-2 2.736V17H6v-5.436a2.91 2.91 0 0 0-2-2.736A3.027 3.027 0 0 1 2.1 5.2c.586-2.1 3.73-2.979 5.183-1.5a1.006 1.006 0 0 0 1.543-.14c1.247-2.08 5.095-2.08 6.342 0a1.007 1.007 0 0 0 1.543.14 3.17 3.17 0 0 1 2.9-.641 3.013 3.013 0 0 1 .39 5.769"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-hat-chef_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrHatChef;
